<footer class="perfil-section-footer" [class.perfil-section-footer--necesidad]="variant === 'necesidad'">
  <div class="perfil-section-footer__inner">
    <div class="perfil-section-footer__info">
      @if (variant === 'necesidad') {
      <div class="perfil-section-footer__coins" aria-hidden="true">
        <span class="perfil-section-footer__bubble perfil-section-footer__bubble--lg"></span>
        <span class="perfil-section-footer__bubble perfil-section-footer__bubble--sm"></span>
        <img class="perfil-section-footer__coin perfil-section-footer__coin--lg" src="assets/img/perfil/moneda-lg.svg"
          alt="" width="51" height="47" />
        <img class="perfil-section-footer__coin perfil-section-footer__coin--sm" src="assets/img/perfil/moneda-sm.svg"
          alt="" width="35" height="32" />
      </div>
      } @else if (iconSrc) {
      <div class="perfil-section-footer__icons" aria-hidden="true">
        <img class="perfil-section-footer__icon perfil-section-footer__icon--back" [src]="iconSrc" alt="" width="40"
          height="40" />
        <img class="perfil-section-footer__icon perfil-section-footer__icon--front" [src]="iconSrc" alt="" width="40"
          height="40" />
      </div>
      }
      <div class="perfil-section-footer__text">
        <p class="perfil-section-footer__title">{{ titulo }}</p>
        <p class="perfil-section-footer__subtitle">{{ subtitulo }}</p>
      </div>
    </div>

    <div class="perfil-section-footer__actions">
      <button type="button" class="perfil-section-footer__continuar" [id]="'btn-perfil-footer-continuar-' + footerId"
        [disabled]="continuarDisabled" (click)="onContinuar()">
        {{ ctaLabel }}
      </button>
      @if (showSaltar) {
      <button type="button" class="perfil-section-footer__link" [id]="'btn-perfil-footer-saltar-' + footerId"
        (click)="onSaltar()">
        {{ copy.botones.saltarPorAhora }}
      </button>
      }
      @if (showGuardar) {
      <button type="button" class="perfil-section-footer__link" [id]="'btn-perfil-footer-guardar-' + footerId"
        (click)="onGuardar()">
        {{ copy.botones.guardarInformacion }}
      </button>
      }
    </div>
  </div>
</footer>